import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material';

export default function ConstructionIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = useTheme().palette.primary.dark;
  const color = props.htmlColor || defaultColor;
  return (
    <SvgIcon
      {...props}
      htmlColor={color}
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 34 34"
      xmlSpace="preserve"
      enableBackground="new 0 0 34 34"
      titleAccess="Construction">
      <g filter="url(#filter0_d_1524_42925)">
        <circle cx={16} cy={12} r={12} fill="#0A4842" />
        <path
          d="M22.346 16.228l-3.488-3.487-1.496 1.496 3.487 3.487a1.052 1.052 0 001.497 0c.409-.416.409-1.087 0-1.496zM19.988 10.588a2.473 2.473 0 002.47-2.47c0-.41-.112-.791-.289-1.13l-1.906 1.906-1.051-1.052 1.906-1.906a2.44 2.44 0 00-1.13-.29 2.473 2.473 0 00-2.47 2.471c0 .29.056.565.148.82l-1.306 1.305-1.257-1.256a.703.703 0 000-.996l-.5-.5 1.496-1.497a2.117 2.117 0 00-2.993 0l-1.99 1.997a.703.703 0 000 .996l.5.5H9.823a.474.474 0 00-.353.15.494.494 0 000 .705l1.793 1.793a.502.502 0 00.854-.353V9.988l.495.494c.275.275.72.275.995 0l1.256 1.257-4.482 4.482a1.052 1.052 0 000 1.496 1.052 1.052 0 001.497 0l7.284-7.277c.261.091.537.148.826.148z"
          fill="#fff"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1524_42925"
          x={0}
          y={0}
          width={32}
          height={32}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1524_42925" />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1524_42925"
            result="shape"
          />
        </filter>
      </defs>
    </SvgIcon>
  );
}
